<template>
  <div>
    <v-dialog v-model="stylesModal" scrollable max-width="800px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Choose a Style </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="$emit('close')" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="mt-4" v-if="selection">
          <v-data-table :items="getStyles" :headers="headers" multi-sort :items-per-page="10" :search="search" class="pa-4">
            <template v-slot:top>
              <v-row>
                <v-text-field
                  v-model="search"
                  label="Styles Search"
                  outlined
                  placeholder="Search"
                  dense
                ></v-text-field>
              </v-row>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="selectStyle(item)">
                <td class="styleFragment" style="width: 150px;">{{ item.fragment }}</td>
                <td style="width: 90px;">{{ item.section }}</td>
                <td v-html="item.preview" class="previewSVG" style="width: 90px;"></td>
                <td class="styleActions" style="width: 90px;">
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-text class="mt-4" v-else>
          <v-data-table :items="getStyles" :headers="headers" multi-sort :items-per-page="10" :search="search" class="pa-4">
            <template v-slot:top>
              <v-row>
                <v-text-field
                  v-model="search"
                  label="Styles Search"
                  outlined
                  placeholder="Search"
                  dense
                ></v-text-field>
              </v-row>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="selectStyle(item)">
                <td class="styleFragment" style="width: 150px;">{{ item.fragment }}</td>
                <td style="width: 90px;">{{ item.section }}</td>
                <td v-html="item.preview" class="previewSVG" style="width: 90px;"></td>
                <td class="styleActions" style="width: 90px;">
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    items: ['all', 'sleeves', 'cap', 'collar', 'torso'],
    search: '',
    dialogCreateEditStyle: false,
    fragment: '',
    headers: [
      {
        text: 'Fragment',
        value: 'fragment'
      },
      {
        text: 'Section',
        value: 'section'
      },
      {
        text: 'Preview',
        value: 'preview'
      },
      {
        text: 'Actions',
        value: 'actions'
      }
    ],
    rules: {
      required: value => !!value || 'Fragment is required',
    }
  }),
  props: {
    stylesModal: Boolean,
    selection: String,
    selectStyle: Function,
  },

  computed: {
      ...mapState(['styles']),
      getStyles: function () {
        return this.styles.filter(style => style.section === this.selection)
      },
      dialog () {
        return this.dialogCreateEditStyle
      },
      fragmentSelected () {
        return this.fragment
      }
    },

}
</script>

<style scoped>
.previewSVG {
  width: 90px;
}
</style>